import React from "react";
import { Link } from "react-router-dom";
import { useSiteContent } from "@/lib/siteContent";
import { useBrand } from "@/lib/brand";

export default function AboutPage() {
  const { content } = useSiteContent();
  const brand = useBrand();
  const paras = (content.story_body || "").split("\n\n");

  return (
    <div className="bg-[#05070C] text-[#E8ECF3]">
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 grid-bg opacity-30 pointer-events-none" />
        <div className="max-w-4xl mx-auto px-6 md:px-12 py-24 md:py-32 relative">
          <div className="label-eyebrow">Our Story</div>
          <h1 className="font-display text-5xl md:text-7xl leading-[1.05] mt-6">
            {content.story_title || "The story behind 2nd Innings"}
          </h1>
          <div className="mt-10 flex items-center gap-4">
            <div className="w-14 h-14 rounded-full bg-[#2DD4BF]/10 border border-[#2DD4BF]/40 flex items-center justify-center text-[#2DD4BF] font-display text-xl">
              {(content.founder_name || "A")[0]}
            </div>
            <div>
              <div className="font-medium text-[#E8ECF3]">{content.founder_name}, {content.founder_age}</div>
              <div className="text-sm text-[#94A3B8]">{content.founder_role}</div>
            </div>
          </div>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-6 md:px-12 pb-24">
        <div className="space-y-6 text-lg leading-relaxed text-[#CBD5E1]">
          {paras.map((p, i) => (
            <p key={i} className={i === 0 ? "text-xl text-[#E8ECF3]" : ""}>
              {p}
            </p>
          ))}
        </div>
        <div className="mt-16 p-8 border border-[#2DD4BF]/30 rounded-2xl bg-[#0A1223]">
          <div className="label-eyebrow mb-3">— {content.founder_name}</div>
          <div className="font-italic-serif text-2xl text-[#E8ECF3] italic">
            "A retired professional is not a closed chapter. They are a library that most of India forgot to borrow from."
          </div>
        </div>
        <div className="mt-12 text-center">
          <Link to="/register">
            <button className="pill-solid h-14 px-10 font-medium">Join the movement</button>
          </Link>
        </div>
      </section>
    </div>
  );
}
